import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';
import FD from '../../RestAPI/fetchData';
import SignUpApproval from '../../Common/signUpApproval';
import TagManager from 'react-gtm-module';
import cookie from 'react-cookies';
import language from '../../../assets/languages/language';
import AppRoutes from '../../config/AppRoutes';
import { GA4SignUp, GTM_ID, GTMSignUp } from '../../../common/constant';
class Filldetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exam: '',
      message: '',
      message_background: 'bg-danger',
      displaytext: 'hide_block',
      token: '',
      idname: '',
      fb_id: this.props.params.fb_id,
      signupAlert: false,
      landingSource: 'organic',
      landingSourceName: null,
      name: this.props.params.name,
    };
    this.updateEmail = this.updateEmail.bind(this);
    this.saveExam = this.saveExam.bind(this);
    this.signUpAlertModel = this.signUpAlertModel.bind(this);
    this.signUpAlertModelClose = this.signUpAlertModelClose.bind(this);
  }

  updateEmail(event) {
    const email_lower = event.target.value.toLowerCase();
    this.setState({ idname: email_lower });
  }

  signUpAlertModel() {
    this.setState({ signupAlert: !this.state.signupAlert });
  }

  signUpAlertModelClose() {
    this.setState({ signupAlert: false });
    browserHistory.push('/');
  }
  saveExam() {
    if (document.getElementById('exam_field').value === '') {
      this.setState({ displaytext: 'show_block' });
      this.setState({ message: 'Exam Field Is Required' });
      return;
    }
    // if(document.getElementById('examlocate').value==="")
    // {
    //   this.setState({displaytext:'show_block'});
    //   this.setState({message:'Exam Location Is Required'});
    //   return;
    // }

    const emailValid = this.state.idname.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if (emailValid) {
      const role = localStorage.getItem('role');
      const organizationDomain = localStorage.getItem('organizationDomain');
      const userData = JSON.parse(localStorage.getItem('userData'));

      const data = {
        idname: this.state.idname,
        fb_id: this.state.fb_id,
        examfield: document.getElementById('exam_field').value,
        organizationDomain,
        role,
        landingSource: this.state.landingSource,
        landingSourceName: this.state.landingSourceName,
        city: userData.city,
        country: userData.country,
        state: userData.state,
        continent: userData.continent,
        ip: userData.ip,
      };

      FD.callAPI(`${App_data.backend_api}/user/savewithFBcheck`, data).then(resp => {
        if (resp.success) {
          localStorage.setItem('loginID', resp.loginID);
          // if (resp.partner) {
          //   this.signUpAlertModel();
          // }
          /*
          -------------------------
            GTM signup event code
          -------------------------
          */
          // if (this.state.landingSource) {
          const tagManagerArgs = {
            gtmId: GTM_ID,
            dataLayer: {
              event: GTMSignUp,
              eventOptions: { selectedExam: document.getElementById('exam_field').value },
              userName: this.state.name,
              userEmail: this.state.idname,
              userExam: document.getElementById('exam_field').value,
              source: this.state.landingSource,
              affiliateName: this.state.landingSourceName,
            },
          };
          TagManager.initialize(tagManagerArgs);
          // ************** For GA4 sign_up event ****************//
          const tagManagerArgsGA4 = {
            gtmId: GTM_ID,
            dataLayer: {
              event: GA4SignUp,
              method: this.state.idname,
            },
          };
          TagManager.initialize(tagManagerArgsGA4);
          // }

          const localStorage_array = {
            token: resp.token,
            idname: this.state.idname,
          };
          localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));

          const exam_status = document.getElementById('exam_field').value;
          if (exam_status === 'cfa') {
            localStorage.setItem('selectedmenu', 'cfa');
            browserHistory.push({
              pathname: AppRoutes.DASHBOARD,
              state: { token: resp.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'cfa_2022') {
            localStorage.setItem('selectedmenu', 'cfa_2022');
            browserHistory.push({
              pathname: AppRoutes.CFA_2022_DASHBOARD,
              state: { token: resp.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'cfa_2_2025') {
            localStorage.setItem('selectedmenu', 'cfa_2_2025');
            browserHistory.push({
              pathname: AppRoutes.CFA2_2025_DASHBOARD,
              state: { token: resp.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'cfa_3') {
            localStorage.setItem('selectedmenu', 'cfa_3');
            browserHistory.push({
              pathname: AppRoutes.CFA3_DASHBOARD,
              state: { token: resp.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'frm') {
            localStorage.setItem('selectedmenu', 'frm');
            browserHistory.push({
              pathname: AppRoutes.FRM_DASHBOARD,
              state: { token: resp.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'soa_p') {
            localStorage.setItem('selectedmenu', 'soa_p');
            browserHistory.push({
              pathname: AppRoutes.SOA_PROBABILITY_DASHBOARD,
              state: { token: this.state.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'soa_fm') {
            localStorage.setItem('selectedmenu', 'soa_fm');
            browserHistory.push({
              pathname: AppRoutes.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
              state: { token: this.state.token, idname: this.state.idname },
            });
          }
          if (exam_status === 'gmat') {
            localStorage.setItem('selectedmenu', 'gmat');
            browserHistory.push({
              pathname: AppRoutes.GMAT_DASHBOARD,
              state: { token: this.state.token, idname: this.state.idname },
            });
          }
        } else {
          this.setState({ displaytext: 'show_block' });
          this.setState({ message: resp.message });
        }
      });
    } else {
      this.setState({ displaytext: 'show_block' });
      this.setState({ message: 'Email Is Not Valid' });
      return;
    }
  }

  componentDidMount() {
    /*
--------------------------------
  Pixel Integration code start
--------------------------------
*/
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    const landingSourceCokkie = cookie.load('utm_source', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (landingSourceCokkie) {
      this.setState({ landingSource: landingSourceCokkie });
    }
    localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
    const checkTapfilliateRefernce = cookie.load('ref', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (checkTapfilliateRefernce) {
      this.setState({
        landingSource: 'tapfiliate',
        landingSourceName: checkTapfilliateRefernce,
      });
      localStorage.setItem('landingSource', 'tapfiliate');
    }

    localStorage.setItem(
      'landingSourceName',
      checkTapfilliateRefernce ? checkTapfilliateRefernce : null,
    );

    /*
-------------------------------
  Pixel Integration code end
-------------------------------    
*/
  }

  render() {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper'>
            <img src={`${App_data.frontend_url}/img/logo1.png`} alt='' width='200' />
          </div>
        </div>
        <div className='row justify-content-center'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-4'>
            <div className='card-group mb-0'>
              <div className='card p-2  '>
                <div className='card-block'>
                  <h4>Select Exam</h4>
                  <p className='text-muted'>Fill Your Details</p>
                  <p
                    className={`${this.state.message_background} ${this.state.displaytext}`}
                    style={{
                      paddingTop: `${4}px`,
                      paddingBottom: `${4}px`,
                      paddingLeft: `${10}px`,
                      fontSize: `${14}px`,
                    }}
                  >
                    {this.state.message}
                  </p>

                  <div className='input-group mb-1'>
                    <span className='input-group-addon-social-registration'>
                      <i className='fa fa-envelope' />
                      {/* <img
                        src={
                          App_data.frontend_url + "/img/profile/mail_ico.svg"
                        }
                        className=""
                        alt=""
                        width="15"
                      /> */}
                    </span>

                    <input
                      type='text'
                      className='form-control'
                      placeholder='Email'
                      value={this.state.idname}
                      onChange={this.updateEmail}
                    />
                  </div>

                  <div className='input-group mb-1'>
                    <span className='input-group-addon-social-registration'>
                      {/* <img
                        src={
                          App_data.frontend_url + "/img/profile/open-book.svg"
                        }
                        className=""
                        alt=""
                        width="15"
                      /> */}
                      <i className='fa fa-book' />
                    </span>
                    <select className='form-control' id='exam_field'>
                      <option value=''>{language.LC().SELECT_EXAM}</option>
                      <option value='cfa'>{language.LC().CFA_1}</option>
                      <option value='cfa_2'>{language.LC().CFA_2}</option>
                      <option value='cfa_3'>{language.LC().CFA_3}</option>
                      <option value='frm'>{language.LC().FRM_PART_1}</option>
                      <option value='frm'>{language.LC().FRM_PART_2}</option>
                      <option value='frm'>
                        {language.LC().FRM_PART_1} & {language.LC().FRM_PART_2}
                      </option>
                      <option value='soa_p'>{language.LC().SOA_PROBABILITY}</option>
                      <option value='soa_fm'>{language.LC().SOA_FINANCIAL}</option>
                    </select>
                  </div>
                  <div className='row'>
                    <div className='col-md-12'>
                      <button
                        type='button'
                        style={{ width: `${100}%` }}
                        className='btn btn-primary'
                        onClick={this.saveExam}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SignUpApproval
            signUpAlertModel={this.signUpAlertModel.bind(this)}
            signUpAlertModelClose={this.signUpAlertModelClose.bind(this)}
            signupAlert={this.state.signupAlert}
          />
        </div>
        <blockquote className='footer-blockquote'>
          <p>{language.LC().FOOTER_MESSAGE}</p>
        </blockquote>{' '}
      </div>
    );
  }
}

export default Filldetails;



// WEBPACK FOOTER //
// ./src/views/Pages/Filldetails/Filldetails.js